import { useCallback, useEffect, useMemo } from "react";
import { useGTMEvent } from "../../../GoogleTagManager/googleTagManagerHooks.js";
import { getAppFeatures } from "../../../../app/appSelectors.js";
import { getPromocodesActive } from "../../bonusesSelectors.js";
import { useDispatch, useSelector } from "react-redux";
import { useInitialUrlSearchParams } from "../../../../hooks/useInitialUrlSearchParams.js";
import { setWelcomeApplyBonusAction } from "../../bonusesActions.js";
import { URL_SEARCH_PARAMS } from "../../../../app/appConstants.js";
import BonusDepositPanelDesktop from "./BonusDepositPanelDesktop";
import { useResponsive } from "../../../../components/responsive";
import BonusDepositPanelMobile from "./BonusDepositPanelMobile";

function BonusDepositPanel(props) {
    const {
        bonusPercent,
        className,
        depositAmount,
        isBonusApplied,
        onChange,
    } = props;
    const dispatch = useDispatch();
    const features = useSelector(getAppFeatures);
    const promocodesActive = useSelector(getPromocodesActive);
    const {isMediumMaxWidth} = useResponsive();

    const {initialOpenBonusTerms, initialApplyBonus} = useInitialUrlSearchParams([
        URL_SEARCH_PARAMS.INITIAL_APPLY_BONUS,
        URL_SEARCH_PARAMS.INITIAL_OPEN_BONUS_TERMS,
    ]);
    useEffect(() => {
        if (initialApplyBonus && !isBonusApplied) {
            dispatch(setWelcomeApplyBonusAction(true));
        }
    }, [dispatch, initialApplyBonus, isBonusApplied]);

    const {handleGTMClick} = useGTMEvent({module: 'BonusDepositPanel'});

    const isShowDepositToBonus = useMemo(() => {
        return features.promocodes && isBonusApplied && promocodesActive.find(item => item.name === 'forever');
    }, [features, promocodesActive, isBonusApplied]);

    const bonusAmount = depositAmount * bonusPercent / 100;

    const handleChange = useCallback((e) => {
        onChange(e.target.checked);
        handleGTMClick({button: 'ApplyBonus', applyBonus: e.target.checked})
    }, [handleGTMClick, onChange]);

    const childrenProps = {
        className,
        depositAmount,
        initialOpenBonusTerms,
        isBonusApplied,
        handleChange,
        bonusPercent,
        bonusAmount,
        isShowDepositToBonus
    };

    // TODO CFD-1578 После обновления макета объединить или доработать BonusDepositPanelDesktop
    return isMediumMaxWidth
        ? <BonusDepositPanelMobile {...childrenProps}/>
        : <BonusDepositPanelDesktop {...childrenProps}/>
}

export default BonusDepositPanel;
